import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { avProgammedPaymentTypeOptions } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'life-insurance-payment',
    templateUrl: './life-insurance-payment.component.html',
    styleUrls: ['./life-insurance-payment.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class LifeInsurancePaymentComponent implements OnInit {
  @Input() derrors: any;
  avProgammedPaymentTypeOptions = avProgammedPaymentTypeOptions;
  constructor(private controlContainer: FormGroupDirective) {}
  get form() {
    return this.controlContainer.form;
  }
  get formAvInvestmentTypeValue() {
    return this.form?.get('parameters')?.get('avInvestmentType')?.value;
  }
  get formAvProgammedPaymentTypeValue() {
    return this.form?.get('parameters')?.get('avProgammedPaymentType')?.value;
  }

  ngOnInit() {}
}
